import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AppService } from '../../services/app.service';
import {
  ChecklistDetailsCategories,
  ChecklistDetailsCheckPoints,
  ChecklistDetailsFileLinkWithThumbnail,
  Checkpoint,
  DealerMediaResponse,
  FileLinkWithThumbnail,
  MapedChecklistDetailsOrder,
  VehicleHealthChecklestResponse,
} from '../../services/client.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { catchError, forkJoin, of } from 'rxjs';
import { VideoPlayerService } from 'src/app/services/video-player.service';
import { isPlatformBrowser } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from 'src/app/video-player/video-player.component';
import { CarouselComponent } from 'src/app/carousel/carousel.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { VehicleWalkthroughComponent } from 'src/app/vehicle-walkthrough/vehicle-walkthrough.component';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { MatSnackBarComponent } from 'src/app/mat-snack-bar/mat-snack-bar.component';

@Component({
  selector: 'app-vehicle-health-report-data',
  templateUrl: './vhc-report.html',
  styleUrls: ['./vhc-report.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatAccordion,
    MatIconModule,
    VideoPlayerComponent,
    CarouselComponent,
    MatDialogModule,
    MatCardModule,
    RouterModule,
    VehicleWalkthroughComponent,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class VhcReport implements OnInit {
  healthReportData: VehicleHealthChecklestResponse | undefined;
  reportResponse: MapedChecklistDetailsOrder | undefined;
  categoryType: string = '';
  token: string = '';
  selectedCategory: any;
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  modelMedia!: FileLinkWithThumbnail[];
  correntSellectedModel: number = 0;
  mediaElememt: string = '';
  @ViewChild('modelVideo') modelVideo!: ElementRef<HTMLVideoElement>;
  selectedCategoryIndex = 0;
  introOutroMediaData!: DealerMediaResponse;
  isWalkthroughEnabled: boolean | undefined = false;
  isAllowed = true;  

  constructor(
    public appService: AppService,
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private videoPlayerService: VideoPlayerService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private snackBar: MatSnackBar,
    private featureFlagService: FeatureFlagService
  ) {}

ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    this.route.queryParams.subscribe((params) => {
      this.categoryType = params['categoryType'];
      this.token = params['token'];

      this.featureFlagService.getFeatures(this.token, 'VHC-Report')
        .then((allowed) => {
          if (!allowed) {
            this.isAllowed = false;
            this.snackBar.openFromComponent(MatSnackBarComponent, {
              data: `The feature "Visual Vehicle Reception Report" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`,
              duration: 10000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
            });
            return;
          }

          forkJoin({
            vhcReport: this.appService.getHealthCheckReport(this.token),
            siteSetting: this.appService.getStyleSettings(this.token).pipe(
              catchError(() => {
                return of(null);
              })
            ),
            dealerMedia: this.appService.getDealerMediaResponse(this.token).pipe(
              catchError(() => {
                return of(null);
              })
            ),
          }).subscribe({
            next: (response: any) => {
              this.introOutroMediaData = response.dealerMedia;
              this.healthReportData = response.vhcReport;

              if (
                this.healthReportData?.urgentRequired &&
                this.categoryType === 'urgentRequired'
              ) {
                this.reportResponse = this.healthReportData.urgentRequired;
              } else if (
                this.healthReportData?.attentionRequired &&
                this.categoryType === 'attentionRequired'
              ) {
                this.reportResponse = this.healthReportData.attentionRequired;
              } else if (
                this.healthReportData?.categoriesOk &&
                this.categoryType === 'categoriesOk'
              ) {
                this.reportResponse = this.healthReportData.categoriesOk;
              }
            }
          });
        })
        .catch(() => {
          this.isAllowed = false;
        });
    });
  }
}


  closeMediaModal() {
    this.videoPlayerService.clearActivePlayer();
    if (this.modelVideo) {
      this.modelVideo.nativeElement.pause();
    }
    this.modalImageUrl = '';
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  scrollToElement(elementId: string) {
    const element = this.document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.error('Element not found:', elementId);
    }
  }

  openMediaModal(
    media: ChecklistDetailsFileLinkWithThumbnail[] | any,
    position: number,
    isWalkthroughEnabled: boolean | undefined = this.isWalkthroughEnabled
  ) {
    this.isWalkthroughEnabled = isWalkthroughEnabled;
    this.modalImageUrl = '';
    if (this.modelVideo) {
      this.modelVideo.nativeElement.load();
    }
    this.modelMedia = media;
    if (position < 0) {
      position = 0;
    }
    if (position >= media.length) {
      position = media.length - 1;
    }
    if (media) {
      this.correntSellectedModel = position;
      this.modalImageUrl = media[position]?.url;
      this.imageModal.nativeElement.style.display = 'block';
      document
        .querySelector('.backdrop')
        ?.setAttribute('style', 'display:block');
    }
    this.mediaElememt = media[position].mimeType.includes('video')
      ? 'video'
      : 'image';
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }

  isAtLeastOneCheckpointDisabled(
    category: ChecklistDetailsCategories
  ): boolean {
    return (
      category?.checkpoints?.some(
        (checkpoint: ChecklistDetailsCheckPoints) =>
          !checkpoint.isWalkthroughEnabled
      ) ?? false
    );
  }


  isCheckpointExpandable(checkpoint: any): boolean {
    return (
      (checkpoint?.findings?.length ?? 0) > 0 ||
      checkpoint.solution ||
      checkpoint.measuredValues?.[0]?.value ||
      (checkpoint.measuredValues?.[0]?.media?.length ?? 0) > 0 ||
      (checkpoint?.media?.length ?? 0) > 0
    );
  }
}
